/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 24/06/2025
 */

import axios from 'axios';
import {encryption} from "../../../../../resources/app/utils/encryption.js";
import {dateHelper} from "./dateHelper.js";

const lskop = import.meta.env.VITE_LS_KEY;
const encrypted = new encryption();

const lsgeo = async () => {
    const isGuest = window.localStorage.getItem("guest") === "isGuest";
    const lsGeoKeyValue = window.localStorage.getItem("gkv");
    let lsKey = window.localStorage.getItem("lsk");
    let secret;

    if (lsKey && lsGeoKeyValue) {
        lsKey = encrypted.decrypt(lsKey, lskop);
        secret = JSON.parse(encrypted.decrypt(lsGeoKeyValue, lsKey));
        if (dateHelper.isDateEarlierThanNow(secret.e)) {
            if(!isGuest) {
                await ajaxClient.get("/sanctum/csrf-cookie");
                await ajaxClient.post('/logout', (secret.i ? {gid: secret.i} : null));
            }
            window.localStorage.removeItem("gkv");
            window.localStorage.setItem("guest", "isGuest");
        } else {
            secret.e = dateHelper.addDay(new Date(),7).format('YYYY-MM-DD HH:mm:ss');
            window.localStorage.setItem("gkv", encrypted.encrypt(JSON.stringify(secret), lsKey));
            return secret;
        }
    } else {
        return null;
    }
}

export const setgeo = async () => {
    const isGuest = window.localStorage.getItem("guest") === "isGuest";
    let lsKey = window.localStorage.getItem("lsk");
    if (!lsKey) {
        lsKey = randomString(32);
        window.localStorage.setItem("lsk", encrypted.encrypt(lsKey, lskop));
    } else {
        lsKey = encrypted.decrypt(lsKey, lskop);
    }

    if (!isGuest) {
        await ajaxClient.get("/sanctum/csrf-cookie");
        await ajaxClient.post('/logout');
    }
    window.localStorage.setItem("guest", "isGuest");

    try {
        const response = await ajaxClient.get('/user/auth');
        const geoData = {
            i: response.data.i,
            k: response.data.k,
            e: response.data.e
        };

        window.localStorage.setItem("gkv", encrypted.encrypt(JSON.stringify(geoData), lsKey));
        return geoData;
    } catch (error) {
        console.error('Error setting geo:', error);
        throw error;
    }
}

const randomString = (length) => {
    let result = '';
    const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

const btok = async () => {
    const secret = await lsgeo();
    return secret && secret.hasOwnProperty('t') ? secret.t : null;
}

export const gid = async () => {
    const secret = await lsgeo();
    return secret && secret.hasOwnProperty('i') ? secret.i : null;
}

// Create axios instances for AJAX and API requests
const ajaxClient = axios.create({
    baseURL: window.location.origin,
    withCredentials: true,
    timeout: (1000 * 60),
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': true
    }
});

const apiClient = axios.create({
    baseURL: window.location.origin + '/api',
    withCredentials : true,
    timeout: (1000*60),
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': true
    }
});

/**
 * Make an AJAX GET request
 * @param {string} url - The URL to send the request to
 * @param {Object} params - Query parameters
 * @param {Object} config - Additional axios config
 * @returns {Promise} A promise that resolves with the response data
 */
export async function ajaxGetRequest(url, params = {}, config = {}) {
    let _config = { ...config, params };
    let geo = await gid();
    if (!geo) {
        try {
            const geoData = await setgeo();
            geo = geoData.i;
        } catch (error) {
            console.error('Failed to set geo:', error);
        }
    }

    _config.headers = { ...(_config.headers || {}) };
    if (geo) {
        _config.headers['app-gid'] = geo;
    }

    return ajaxClient.get(url, _config)
        .then(response => response.data)
        .catch(error => {
            console.error('AJAX GET Error:', error);
            throw error;
        });
}

/**
 * Make an AJAX POST request
 * @param {string} url - The URL to send the request to
 * @param {Object} data - The data to send with the request
 * @param {Object} config - Additional axios config
 * @returns {Promise} A promise that resolves with the response data
 */
export async function ajaxPostRequest(url, data = {}, config = {}) {
    let _config = { ...config };
    let geo = await gid();
    if (!geo) {
        try {
            const geoData = await setgeo();
            geo = geoData.i;
        } catch (error) {
            console.error('Failed to set geo:', error);
        }
    }

    _config.headers = { ...(_config.headers || {}) };
    if (geo) {
        _config.headers['app-gid'] = geo;
    }

    await ajaxClient.get("/sanctum/csrf-cookie");
    return ajaxClient.post(url, data, _config)
        .then(response => response.data)
        .catch(error => {
            // console.error('AJAX POST Error:', error);
            throw error;
        });
}

/**
 * Make an AJAX POST request to sign out
 * @returns {Promise} A promise that resolves with the response data
 */
export async function signOutRequest() {
    let _config = {};
    let geo = await gid();

    _config.headers = {};
    if (geo) {
        _config.headers['app-gid'] = geo;
    }

    try {
        await ajaxClient.get("/sanctum/csrf-cookie");
        const response = await ajaxClient.post('/logout', (geo?{ gid: geo }:null), _config);

        window.localStorage.removeItem("gkv");
        window.localStorage.setItem("guest", "isGuest");

        return response.data;
    } catch (error) {
        // console.error('Sign Out Error:', error);
        throw error;
    }
}

/**
 * Make an API GET request
 * @param {string} url - The URL to send the request to
 * @param {Object} params - Query parameters
 * @param {Object} config - Additional axios config
 * @returns {Promise} A promise that resolves with the response data
 */
export async function apiGetRequest(url, params = {}, config = {}) {
    const token = await btok();
    let _config = { ...config, params };
    let geo = await gid();
    if (!geo) {
        try {
            const geoData = await setgeo();
            geo = geoData.i;
        } catch (error) {
            console.error('Failed to set geo:', error);
        }
    }

    _config.headers = { ...(_config.headers || {}) };

    if (geo) {
        _config.headers['app-gid'] = geo;
    }

    if (token) {
        _config.headers['Authorization'] = `Bearer ${token}`;
    }

    return apiClient.get(url, _config)
        .then(response => response.data)
        .catch(error => {
            // console.error('API GET Error:', error);
            throw error;
        });
}

/**
 * Make an API POST request
 * @param {string} url - The URL to send the request to
 * @param {Object} data - The data to send with the request
 * @param {Object} config - Additional axios config
 * @returns {Promise} A promise that resolves with the response data
 */
export async function apiPostRequest(url, data = {}, config = {}) {
    const token = await btok();
    let _config = { ...config };
    let geo = await gid();

    if (!geo) {
        try {
            const geoData = await setgeo();
            geo = geoData.i;
        } catch (error) {
            console.error('Failed to set geo:', error);
        }
    }

    _config.headers = { ...(_config.headers || {}) };

    if (geo) {
        _config.headers['app-gid'] = geo;
    }

    if (token) {
        _config.headers['Authorization'] = `Bearer ${token}`;
    }

    return apiClient.post(url, data, _config)
        .then(response => response.data)
        .catch(error => {
            // console.error('API POST Error:', error);
            throw error;
        });
}
